export default __webpack_public_path__ + "static/media/assessment_glide_3_2.d8b2515e.svg";